export default {
  signIn: 'Inloggen',
  signOut: 'Uitloggen',
  points: 'punten',
  hyattSignInButton: 'Inloggen bij World of Hyatt',
};
